import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import TaskFormModal from 'bundles/apex/tasks/task_modal';

const AddControl = props => <Button icon={faCirclePlus} size="sm" variant="ghost" {...props} />;

export default function AddTask({
  className,
  createTask,
  displayAs,
  formDependenciesPath,
  showType = false,
}) {
  const [showModal, setShowModal] = useState();
  const AddComponent = displayAs || AddControl;

  return <React.Fragment>
    <AddComponent aria-label="Add task" className={className} onClick={() => setShowModal(true)}>
      Add task
    </AddComponent>

    <TaskFormModal
      createTask={createTask}
      formDependenciesPath={formDependenciesPath}
      show={showModal}
      showType={showType}
      onHide={() => setShowModal(false)}
      onSave={() => setShowModal(false)}
    />
  </React.Fragment>;
}

AddTask.propTypes = {
  className: PropTypes.string,
  createTask: PropTypes.func,
  displayAs: PropTypes.elementType,
  formDependenciesPath: PropTypes.string,
  showType: PropTypes.bool,
};
